import React, { useMemo } from 'react';
import { useField } from 'react-final-form';

import { RoundedCornerOutlined } from '@mui/icons-material';
import { InputLabel, Stack } from '@mui/material';

import RawSliderInput from '../raw/RawSliderInput';

type Props = {
  label: string;
  name: string;
};
export default function BorderRadius({ label, name }: Props) {
  const { input } = useField(name);

  const onChange = (value: number) => {
    const v = value === 0 ? null : `${value}px`;
    input.onChange(v);
  };
  const value = useMemo(() => {
    const v = parseInt(input.value);
    return isNaN(v) ? 0 : v;
  }, [input]);

  return (
    <Stack alignItems="flex-start">
      <InputLabel sx={{ mb: 0.5 }}>{label}</InputLabel>
      <RawSliderInput
        {...{ value, onChange }}
        label={<RoundedCornerOutlined />}
        units="px"
        step={4}
        marks
        min={0}
        max={48}
      />
    </Stack>
  );
}
